export const order_counter_url: string = "order_counter";